import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function usePdfReset() {
  const resetGlocoseData = Recoil.useResetRecoilState(AppStore.assets.data('ReportBloodGlocose'));
  const resetDietData = Recoil.useResetRecoilState(AppStore.assets.data('ReportDiet'));
  const resetCaloriesData = Recoil.useResetRecoilState(AppStore.assets.data('ReportExerciseCalories'));
  const resetStepsData = Recoil.useResetRecoilState(AppStore.assets.data('ReportExerciseSteps'));
  const resetInsulinData = Recoil.useResetRecoilState(AppStore.assets.data('ReportInsulin'));

  const resetGlocoseHighList = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseHighList'));
  const resetGlocoseLowList = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseLowList'));

  const resetGlocoseProfileChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseProfileChart'));
  const resetGlocoseTIRChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseTIRChart'));
  const resetGlocoseDistributionBarChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseDistributionBarChart'));
  const resetGlocoseDistributionScatterChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocoseDistributionScatterChart'));
  const resetGlocosePatternWeekdayChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocosePatternWeekdayChart'));
  const resetGlocosePatternWeekendChart = Recoil.useResetRecoilState(AppStore.assets.data('GlocosePatternWeekendChart'));
  const resetDietDistributionDoughnutChart = Recoil.useResetRecoilState(AppStore.assets.data('DietDistributionDoughnutChart'));
  const resetDietDistributionScatterChart = Recoil.useResetRecoilState(AppStore.assets.data('DietDistributionScatterChart'));
  const resetDietMealAnalysisList = Recoil.useResetRecoilState(AppStore.assets.data('DietMealAnalysisList'));
  const resetDietFoodAnalysisList = Recoil.useResetRecoilState(AppStore.assets.data('DietFoodAnalysisList'));
  const resetDietStatisticsChart = Recoil.useResetRecoilState(AppStore.assets.data('DietStatisticsChart'));
  const resetDietDailyStatistics = Recoil.useResetRecoilState(AppStore.assets.data('DietDailyStatistics'));
  const resetStepAnalysisDayChart = Recoil.useResetRecoilState(AppStore.assets.data('StepAnalysisDayChart'));
  const resetStepAnalysisWeekChart = Recoil.useResetRecoilState(AppStore.assets.data('StepAnalysisWeekChart'));
  const resetStepStatisticsChart = Recoil.useResetRecoilState(AppStore.assets.data('StepStatisticsChart'));
  const resetCaloryAnalysisDayChart = Recoil.useResetRecoilState(AppStore.assets.data('CaloryAnalysisDayChart'));
  const resetCaloryAnalysisWeekChart = Recoil.useResetRecoilState(AppStore.assets.data('CaloryAnalysisWeekChart'));
  const resetCaloryStatisticsChart = Recoil.useResetRecoilState(AppStore.assets.data('CaloryStatisticsChart'));
  const resetExerciseDailyStatisticsList = Recoil.useResetRecoilState(AppStore.assets.data('ExerciseDailyStatisticsList'));
  const resetInsulinDistributionDoughnutChart = Recoil.useResetRecoilState(AppStore.assets.data('InsulinDistributionDoughnutChart'));
  const resetInsulinDistributionScatterChart = Recoil.useResetRecoilState(AppStore.assets.data('InsulinDistributionScatterChart'));
  const resetInsulinBolusAnalysisList = Recoil.useResetRecoilState(AppStore.assets.data('InsulinBolusAnalysisList'));
  const resetInsulinStatisticsChart = Recoil.useResetRecoilState(AppStore.assets.data('InsulinStatisticsChart'));
  const resetInsulinPatternTimeList = Recoil.useResetRecoilState(AppStore.assets.data('InsulinPatternTimeList'));
  const resetInsulinStatisticsDayChart = Recoil.useResetRecoilState(AppStore.assets.data('InsulinStatisticsDayChart'));
  const resetInsulinStatList = Recoil.useResetRecoilState(AppStore.assets.data('InsulinStatList'));

  const reset = React.useCallback(() => {
    resetGlocoseData();
    resetDietData();
    resetCaloriesData();
    resetStepsData();
    resetInsulinData();

    resetGlocoseHighList();
    resetGlocoseLowList();

    resetGlocoseProfileChart();
    resetGlocoseTIRChart();
    resetGlocoseDistributionBarChart();
    resetGlocoseDistributionScatterChart();
    resetGlocosePatternWeekdayChart();
    resetGlocosePatternWeekendChart();
    resetDietDistributionDoughnutChart();
    resetDietDistributionScatterChart();
    resetDietMealAnalysisList();
    resetDietFoodAnalysisList();
    resetDietStatisticsChart();
    resetDietDailyStatistics();
    resetStepAnalysisDayChart();
    resetStepAnalysisWeekChart();
    resetStepStatisticsChart();
    resetCaloryAnalysisDayChart();
    resetCaloryAnalysisWeekChart();
    resetCaloryStatisticsChart();
    resetExerciseDailyStatisticsList();
    resetInsulinDistributionDoughnutChart();
    resetInsulinDistributionScatterChart();
    resetInsulinBolusAnalysisList();
    resetInsulinStatisticsChart();
    resetInsulinPatternTimeList();
    resetInsulinStatisticsDayChart();
    resetInsulinStatList();
  }, [resetGlocoseData, resetDietData, resetCaloriesData, resetStepsData, resetInsulinData, resetGlocoseHighList, resetGlocoseLowList, resetGlocoseProfileChart, resetGlocoseTIRChart, resetGlocoseDistributionBarChart, resetGlocoseDistributionScatterChart, resetGlocosePatternWeekdayChart, resetGlocosePatternWeekendChart, resetDietDistributionDoughnutChart, resetDietDistributionScatterChart, resetDietMealAnalysisList, resetDietFoodAnalysisList, resetDietStatisticsChart, resetDietDailyStatistics, resetStepAnalysisDayChart, resetStepAnalysisWeekChart, resetStepStatisticsChart, resetCaloryAnalysisDayChart, resetCaloryAnalysisWeekChart, resetCaloryStatisticsChart, resetExerciseDailyStatisticsList, resetInsulinDistributionDoughnutChart, resetInsulinDistributionScatterChart, resetInsulinBolusAnalysisList, resetInsulinStatisticsChart, resetInsulinPatternTimeList, resetInsulinStatisticsDayChart, resetInsulinStatList]);
  return reset;
}
